import { render, staticRenderFns } from "./DetailRiwayatPengajuanProduk.vue?vue&type=template&id=36ee51a8&"
import script from "./DetailRiwayatPengajuanProduk.vue?vue&type=script&lang=js&"
export * from "./DetailRiwayatPengajuanProduk.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports